module.exports = __webpack_public_path__ + "static/media/thumbnail-szekesfehervar-biztber-kialakitas-resz-projektmendzsment.255bbb3f.jpg";